/* eslint-disable no-mixed-operators */
/* eslint-disable max-len */
import { Axis } from '../../axis/axis.class';
import { Vertex3 } from '../vertex-3.class';

export const rotate3Cfn = (point: Vertex3, origin: Vertex3, axis: Axis): Vertex3 => {
	// Translate point back to origin
	let p = {
		x: point.x - origin.x,
		y: point.y - origin.y,
		z: point.z - origin.z
	};

	// Rotate in each axis
	p = {
		x: p.x * Math.cos(axis.yr) * Math.cos(axis.zr) - p.y * Math.sin(axis.zr) + p.z * Math.sin(axis.yr),
		y: p.x * (Math.sin(axis.zr) * Math.cos(axis.yr) + Math.cos(axis.zr) * Math.sin(axis.xr) * Math.sin(axis.yr)) + p.y * (Math.cos(axis.zr) * Math.cos(axis.xr)) - p.z * Math.cos(axis.yr) * Math.sin(axis.xr),
		z: p.x * (Math.sin(axis.zr) * Math.sin(axis.xr) * Math.sin(axis.yr) - Math.cos(axis.zr) * Math.sin(axis.yr)) + p.y * Math.sin(axis.zr) * Math.cos(axis.xr) + p.z * Math.cos(axis.yr) * Math.cos(axis.xr)
	};

	// Translate point back
	point.x = p.x + origin.x;
	point.y = p.y + origin.y;
	point.z = p.z + origin.z;

	return point;
}

